import UTILITY_API from "../utility_api";

const getActivityCodesForFundingCategory = (funding_category, query) => {
  const matchingObjects = funding_category.filter((element) =>
    query.includes(element.proposed_funding_category)
  );

  const activityCodes = matchingObjects.map((obj) => ({
    funding_category: obj.proposed_funding_category,
    activity_codes: obj.activity_codes,
  }));

  return activityCodes.length > 0 ? activityCodes : null;
};

const fetchFundingCategory = async (category) => {
  try {
    const funding_category = await fetch(UTILITY_API + "/funding_category");
    if (!funding_category.ok) {
      throw new Error(`First API call failed: ${funding_category.statusText}`);
    }
    const funding_category_data = await funding_category.json();
    const activityCodes = getActivityCodesForFundingCategory(
      funding_category_data,
      category
    );

    if (activityCodes) {
      const flattenedActivityCodes = activityCodes.flatMap(
        (obj) => obj.activity_codes
      );
      let updateDataQuery = {
        activitycodes: flattenedActivityCodes.join(","),
      };
      return updateDataQuery;
    }
  } catch (error) {
    console.error("Failed to fetch data:", error);
  }
};

export const handleFundingCategoryHelper = async (selectedOption) => {
  let category = [];
  selectedOption.map((item) => {
    category.push(item.value);
  });
  let updateDataQuery = await fetchFundingCategory(category);
  return updateDataQuery;
};
